export default __webpack_public_path__ + "static/geetajayanti4-2928e9cd14a48c06d9790189b998f417.jpg";